import { select, call, put, takeEvery } from "redux-saga/effects"

// Types
import AdministrationTypes from "Containers/Administration/types"

// Saga
import {
  responseTypeIsError,
  responseTypeIsSuccess,
  responseTypeIsWarning,
  manageErrorGenerator,
  manageSuccessGenerator,
  manageWarningGenerator,
} from "Containers/App/saga"

// Actions
import {
  setSuccessMessage,
  setErrorMessage,
  removeErrorMessage,
  removeSuccessMessage,
} from "Containers/Messages/actions"

import {
  getOrganigrammeSuccessAction,
  getOrganigrammeAction,
  getUsersSuccessAction,
  getProfilsSuccessAction,
  getUsersAction,
} from "Containers/Administration/actions"

// Selectors
import { selectCurrentToken } from "Containers/Login/selectors"
import { selectBusiness } from "Containers/BusinessInformations/selectors"
// Utils
import { getCors, postCors, patchCors, deleteCors } from "Utils/rulesCors"
import { config } from "Utils/config"
import request from "Utils/request"
//***************************************************/
//***                ORGANIGRAMME                 ***/
//***************************************************/
function* getOrganigramme({ payload }) {
  const token = yield select(selectCurrentToken)
  const action = payload?.action || "" // Temporaire afin de récupérer une fake source

  const requestURL =
    action === "useFakeData"
      ? `${config?.API_URL}/groupTree?action=useFakeData`
      : `${config?.API_URL}/groupTree`

  try {
    const response = yield call(request, requestURL, getCors({ token }))
    if (responseTypeIsError(response)) {
      console.error(`[route] => /groupTree => ERROR GET => `, response)
    } else {
      yield put(getOrganigrammeSuccessAction(response?.body))
    }
  } catch (err) {
    console.error(`[route] => /groupTree => ERROR GET => `, err)
  }
}

function* postOrganigramme({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const requestURL = `${config?.API_URL}/groups`

  try {
    const response = yield call(request, requestURL, postCors(payload, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsWarning(response)) {
      yield call(manageWarningGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getOrganigrammeAction())
    }
  } catch (err) {
    console.error("[route] --> /groups | POST | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}
//***************************************************/
//***                UTILISATEURS                 ***/
//***************************************************/
export function* getBusinessUsers() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/businessUsers`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getUsersSuccessAction(response))
      return response.body
    }
  } catch (err) {
    console.error("[route] => /businessUsers/:id => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

export function* postBusinessUsers({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)

  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/businessUsers`

  try {
    const response = yield call(request, requestURL, postCors(payload, specificHeaders))

    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      yield put(getUsersAction({ businessId: business?._id?.$oid }))
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] => /businessUsers => ERROR => ", err)
    yield put(setErrorMessage(response))
  }
}

function* patchBusinessUsers({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/businessUsers/${payload?.userId}`

  try {
    const response = yield call(request, requestURL, patchCors(payload, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      yield put(getUsersAction({ businessId: business?._id?.$oid }))
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] => /businessUsers => ERROR => ", err)
    yield put(setErrorMessage(response))
  }
}

function* deleteBusinessUsers({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/businessUsers/${payload?.userId}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      yield put(getUsersAction({ businessId: business?._id?.$oid }))
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] => /businessUsers => ERROR => ", err)
    yield put(setErrorMessage(response))
  }
}
//***************************************************/
//***                  PROFILS                    ***/
//***************************************************/
// export function* getBusinessProfils() {
//   const token = yield select(selectCurrentToken)
//   const specificHeaders = { token: token }
//   const { API_URL } = config
//   const requestURL = `${API_URL}/businessProfils`

//   try {
//     const response = yield call(request, requestURL, getCors(specificHeaders))
//     if (responseTypeIsError(response))
//       yield call(manageErrorGenerator, { response, showMessageToUser: true })
//     else {
//       if (responseTypeIsSuccess(response))
//         yield call(manageSuccessGenerator, { response, showMessageToUser: false })
//       yield put(getProfilsSuccessAction(response))
//       return response.body
//     }
//   } catch (err) {
//     console.error("[route] => /businessProfils/:id => ERROR => ", err)
//     yield put(setErrorMessage(err))
//   }
// }

function* administrationSaga() {
  yield takeEvery(AdministrationTypes.GET_ORGANIGRAMME, getOrganigramme)
  yield takeEvery(AdministrationTypes.POST_ORGANIGRAMME, postOrganigramme)
  yield takeEvery(AdministrationTypes.GET_USERS, getBusinessUsers)
  yield takeEvery(AdministrationTypes.POST_USERS, postBusinessUsers)
  yield takeEvery(AdministrationTypes.PATCH_USERS, patchBusinessUsers)
  yield takeEvery(AdministrationTypes.DELETE_USERS, deleteBusinessUsers)
  // yield takeEvery(AdministrationTypes.GET_PROFILS, getBusinessProfils)
}

export default administrationSaga
